module.exports = __webpack_public_path__ + "img/q2-4.bdd2e566.png";